<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-invite-modal" v-if="!team_switch">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="share-text">
                        <p><b>【{{ player_data.playerName }}】</b>邀请你加入他的梦之小队，</p>
                        <p>组队成功后可获得集结大礼包一份！</p>
                    </div>
                </div>

                <button class="u-btn apply" @click="team_switch = true"></button>      
            </div>         
        </div>
        <div class="u-window m-msg-modal" v-if="team_switch">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
            <div class="dialog-body">
                <div class="dialog-text">
                    确认加入<b>【{{ player_data.playerName }}】</b>的队伍吗？
                </div>

                <div class="u-btn ok" @click="apply_team"></div>
            </div>   
            </div>         
        </div>  
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : () => {},
            team_switch : false,
        }
    },
    created (){
        // if(!this.$store.state.login){
        //     return this.$mslogin.open();
        // }

        // if(!this.$store.state.userinfo){
        //     this.$bind_modal();
        //     return this.$toast('请先选择大区');
        // }

        this.render();
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite_info,{
                params : {
                    key : this.code,
                }
            })
            .then(res => {
                this.player_data = res.data;
            },rej => {
                //this.destroyElement();
                this.$toast('请稍后再试')
            });
        },
        apply (){

            if(!this.$store.state.userinfo.uid)return this.$mslogin.open();
            if(!this.$store.state.userinfo.areaId)return this.$bind_modal();

            this.$comfirm_modal({
                name : this.player_data.playerName,
                code : this.code,
            });
        },
        apply_team (){
            this.$axios.post(ajax_url_map.accept,this.$qs.stringify({
                key : this.code,
            }))
            .then(
                res => {
                    this.destroyElement();
                    this.$msgs_modal({text : '你的入队申请已提交给队长，请耐心等待。'});
                    localStorage.setItem('code', '');
                },
                rej => {
                    this.destroyElement();
                    this.$msgs_modal({text : rej.message || '请稍后再试'});
                    localStorage.setItem('code', '');
                }
            );
        },                
    },
}
</script>

<style scoped>
/* share */
.m-invite-modal {
    width: 663px;
    height: 408px;
    background-image: url(~@/assets/images/utils/bg-modal-invite_apply.png);
}

.m-invite-modal .u-btn.close{
    top: -15px;
    right: -40px;    
    width: 34px;
    height: 34px;
    background-image: url(~@/assets/images/utils/btn-close_2.png);
}


.m-invite-modal .share-text {
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 518px;
    height: 178px;
    box-sizing: border-box;
    margin-left: -259px;
    padding: 30px 50px 0;
    font-size: 22px;
    color: #715835;
    text-align: center;
}

.share-text b{
    color: #d45c3d;
}

.m-invite-modal .u-btn.apply {
    position: absolute;
    left: 50%;
    bottom: -31px;
    width: 222px;
    height: 66px;
    margin-left: -111px;
    background-image: url(~@/assets/images/utils/btn-invite_apply.png);
}

.m-msg-modal {
    width: 504px;
    height: 304px;
    background-image: url(~@/assets/images/utils/bg-modal-smsg.png);
}

.m-msg-modal .dialog-wrapper{
    padding: 90px 40px 0;
}

.dialog-text {
    font-size: 22px;
    color: #a1837d;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    color: #715835;
    text-align: center;    
    margin-bottom: 4px;
}

.dialog-text b{
    color: #d45c3d;
}

.u-btn.ok {
    position: absolute;
    left: 50%;
    bottom: 42px;
    width: 222px;
    height: 66px;
    margin-left: -111px;
    background-image: url(~@/assets/images/utils/btn-ok.png);
}
</style>


// WEBPACK FOOTER //
// src/components/InviteApply/inviteApply.vue